<template>
  <div>
    <div class="text-center">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
  <v-dialog v-model="dialogNoShop" persistent max-width="400px">
    <v-card height="320">
      <v-card-title >
        <v-icon color="#FFCC80" class="icon">mdi-information-outline</v-icon>
      </v-card-title>
      <v-card-text class="text-center dialog-content">
        <h4>ไม่พบร้านค้า</h4>
        <p>กรุณาติดต่อเจ้าหน้าที่ เพื่อทำการแก้ไขหรือทำการเพิ่มข้อมูลร้านค้า</p>
        <div class="text-center">
          <v-btn
            rounded
            color="success"
            dark
            @click="gotoLinkNoShop()"
          >
            ติดต่อที่นี่
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" persistent max-width="400px">
    <v-card height="300">
      <v-card-title >
        <v-icon color="#FFCC80" class="icon">mdi-information-outline</v-icon>
      </v-card-title>
      <v-card-text class="text-center dialog-content">
        <h4>ยังไม่ได้เปิดระบบจองคิวกับ BeTask</h4>
        <p>กรุณากดติดต่อเจ้าหน้าที่</p>
        <div class="text-center">
          <v-btn
            rounded
            color="success"
            dark
            @click="gotoLink()"
          >
            ติดต่อที่นี่
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      overlay: true,
      shopId: '',
      dataShop: [],
      timeSlotStatus: '',
      sourceLink: '',
      UIDEx10: '',
      dialogNoShop: false,
      dialogError: false,
      channelId: ''
    }
  },
  mounted () {
    this.shopId = this.$route.query.shopId
    this.sourceLink = this.$route.query.source
    this.UIDEx10 = this.$route.query.uid
    this.channelId = this.$route.query.channelId
    console.log(this.shopId)
    console.log(this.sourceLink)
    console.log(this.UIDEx10)
    console.log(this.$route.query)

    if (!this.shopId || !this.UIDEx10) {
      this.dialogError = true
      return
    }

    this.getShopByLineConfig()
    this.getShop()
    setTimeout(() => {
      this.overlay = false
    }, 3000)
  },
  methods: {
    async getShopByLineConfig () {
      try {
        if (this.shopId) {
          const response = await axios.get(this.DNS_IP + '/lineconfig/get?shopId=' + this.shopId)
          let rs = response.data
          console.log(rs)
          if (rs && rs.status !== false) {
            console.log('rs by line config', rs)
          } else {
            this.dialogNoShop = true
            this.dialogError = false
            console.log('rs : ', rs)
          }
        } else {
          this.dialogNoShop = true
          this.dialogError = false
          console.log('ไม่มีร้านนี้')
        }
      } catch (error) {
        this.dialogError = true
        this.dialogNoShop = false
        console.error('มีข้อผิดพลาดในการเรียกข้อมูลgetshop:', error.message)
      }
    },
    async getShop () {
      try {
        if (this.shopId) {
          const response = await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId)
          let rs = response.data
          console.log('rs:', rs)
          this.dataShop = rs
          this.timeSlotStatus = this.dataShop[0].timeSlotStatus
          console.log(this.timeSlotStatus)
          if (this.timeSlotStatus === 'True') {
            // console.log('Log True')
            window.location.href = `/BookingFormEmpEx10?shopId=${this.shopId}&channelId=${this.channelId}&source=${this.sourceLink}&uid=${this.UIDEx10}`
          } else {
            // console.log('Log False')
            window.location.href = `/BookingFormEx10?shopId=${this.shopId}&channelId=${this.channelId}&source=${this.sourceLink}&uid=${this.UIDEx10}`
          }
        }
      } catch (error) {
        this.dialogError = true
        this.dialogNoShop = false
        console.error('มีข้อผิดพลาดในการเรียกข้อมูล:', error.message)
      }
    },
    async gotoLink () {
      window.open('https://belinked.betaskthai.com/register?_gl=1%2aqo1qmh%2a_gcl_au%2aMTg4MTc1MzUzNi4xNzE3NjQ1NTIy%2a_ga%2aMTU2ODUxNTA4Mi4xNzE3NjQ1NTIy%2a_ga_Q1V828FPQH%2aMTcxNzY0NTUyMS4xLjEuMTcxNzY0NTUzMC41MS4wLjA.')
    },
    async gotoLinkNoShop () {
      window.open('https://betaskthai.com/contact_us/?_gl=1*17l7eja*_ga*MTU2ODUxNTA4Mi4xNzE3NjQ1NTIy*_ga_Q1V828FPQH*MTcxNzY0NTUyMS4xLjEuMTcxNzY0NzQzMC42MC4wLjA.')
    }
  }
}
</script>

<style scoped>
.icon{
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 100px;
  margin: auto;
}
p{
  font-size: 18px;
  margin: 20px 10px 20px;
}
h4{
  font-weight: bold;
  margin: 20px 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/BookingSwitch.vue